import { ColumnType } from '@datachain/ui-sdk/components/dc-types';
import produce, { immerable } from 'immer';

interface IDepotHeaderItemEntity {
	id: number;
	label: string; // entity label
	columnType: ColumnType;
	isList: boolean;
	format: string | null;
	timezone: string | null;
	language: string | null;
	header: string; // Repo header
	headerType: ColumnType;
	position: number;
	depotDetails: boolean;
	isSelected: boolean;
}

const entityDefaults: IDepotHeaderItemEntity = {
	id: -1,
	label: '',
	columnType: ColumnType.Unknown,
	isList: false,
	format: null,
	timezone: null,
	language: null,
	header: '',
	headerType: ColumnType.Unknown,
	position: -1,
	depotDetails: false,
	isSelected: true,
};

export class DepotHeaderItemEntity implements IDepotHeaderItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public columnType = entityDefaults.columnType;
	public isList = entityDefaults.isList;
	public format = entityDefaults.format;
	public timezone = entityDefaults.timezone;
	public language = entityDefaults.language;
	public header = entityDefaults.header;
	public headerType = entityDefaults.headerType;
	public position = entityDefaults.position;
	public depotDetails = entityDefaults.depotDetails;
	public isSelected = entityDefaults.isSelected;

	public static build(
		params: Partial<IDepotHeaderItemEntity> = {}
	): DepotHeaderItemEntity {
		const instance = new DepotHeaderItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.columnType = params.columnType ?? entityDefaults.columnType;
		instance.isList = params.isList ?? entityDefaults.isList;
		instance.format = params.format ?? entityDefaults.format;
		instance.timezone = params.timezone ?? entityDefaults.timezone;
		instance.language = params.language ?? entityDefaults.language;
		instance.header = params.header ?? entityDefaults.header;
		instance.headerType = params.headerType ?? entityDefaults.headerType;
		instance.position = params.position ?? entityDefaults.position;
		instance.depotDetails = params.depotDetails ?? entityDefaults.depotDetails;
		instance.isSelected = params.isSelected ?? entityDefaults.isSelected;
		return instance;
	}

	public setIsList(isList: boolean): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.isList = isList;
		});
	}

	public setHeader(header: string): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.header = header;
		});
	}

	public setHeaderType(type: ColumnType): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.headerType = type;
		});
	}

	public setLabel(label: string): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.label = label;
		});
	}

	public setColumnType(columnType: ColumnType): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.columnType = columnType;
		});
	}

	public setFormat(format: string | null): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.format = format;
		});
	}

	public setTimezone(timezone: string | null): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.timezone = timezone;
		});
	}

	public setLanguage(language: string | null): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.language = language;
		});
	}

	public setIsSelected(isSelected: boolean): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.isSelected = isSelected;
		});
	}

	public setPosition(position: number): DepotHeaderItemEntity {
		return produce(this, (draft: DepotHeaderItemEntity) => {
			draft.position = position;
		});
	}
}
